export default __webpack_public_path__ + "static/media/servicios_4.e8cdba15.jpg";